// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"259":"component---src-pages-editor-js","269":"component---src-templates-storyblok-entry-js","351":"commons"}[chunkId] || chunkId) + "-" + {"259":"3466888bd0eb8e8a315f","269":"8dd17b0e5c8333805456","351":"13a928ae5f296ffc93df","954":"2bcabbed248e35b0a7dc"}[chunkId] + ".js";
};